import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button as MuiButton } from "@mui/material";

import styled from "styled-components";
import { Loader } from "../components/UI/Loader";
import { request } from "../utils/axios-utils";
import Form from "../components/Forms/EditForm";

const ChangeSettings = () => {
  const [data, setData] = useState();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { id }: any = useParams();

  const handleDelete = () => {
    if (window.confirm("Вы уверены что хотите удалить?")) {
      request({ url: `api/v2/project/delete?id=${id}`, method: "delete" }).then(
        () => {
          navigate("/panel");
        }
      );
    }
  };

  useEffect(() => {
    request({
      url: `api/v2/project?id=${id}`,
    }).then((res) => {
      setData(res.data);
    });
  }, [id]);

  return (
    <Container>
      <div className="top_box">
        <p>{t("controlPanelUpdatePageHeader")} </p>
        <MuiButton
          variant="contained"
          onClick={handleDelete}
          color="error"
          size="small"
        >
          {t("controlPanelUpdatePageDeleteButton")}
        </MuiButton>
      </div>
      <div className="box">
        {data ? <Form value={data} id={id} /> : <Loader />}
      </div>
    </Container>
  );
};

export default ChangeSettings;

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  & h1 {
    font-size: 24px;
    text-align: center;
  }

  .top_box {
    max-width: 40rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1.5rem;
    border: none;
    outline: none;
    border-bottom-right-radius: none;
    border-bottom-left-radius: none;
    border-top-right-radius: 0.25rem;
    border-top-left-radius: 0.25rem;
    color: #121212;
    background: #9bc2e0;
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 10%),
      0 4px 6px -2px rgb(0 0 0 / 5%);

    p {
      font-size: 18px;
      padding: 0 10px;
    }

    @media screen and (max-width: 767px) {
      max-width: 18rem;
    }
  }

  .box {
    max-width: 40rem;
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 2rem 2.5rem;
    flex-direction: column;
    gap: 10px;
    border: none;
    outline: none;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: none;
    border-top-left-radius: none;
    color: #121212;
    background: #ffffff;
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 10%),
      0 4px 6px -2px rgb(0 0 0 / 5%);

    @media screen and (max-width: 767px) {
      max-width: 18rem;
    }
  }
`;
